<template>
	<div class="">
		<div class="row">
			<div
				class="col-12 mb-4"
			>
				<b-button variant="link" class="p-0 mb-4 d-none d-lg-block" @click="setStep(STEPS.INFO)">
					Вернуться назад
				</b-button>
				<div class="title mb-4">
					Сведения о компании
				</div>
				<FormulateForm
					v-model="values"
					name="companyStep"
					remove-label
					@submit="submitHandler"
					@failed-validation="formErrorHandler"
				>
					<div class="row mb-4">
						<div class="col-12 col-lg-6 mb-4">
							<FormulateInput
								name="company_name_legal"
								type="CustomDadataCompany"
								label="Название*"
								:input_options="{placeholder: 'Введите значение'}"
								:validation="'required'"
								validation-name="company"
								:validation-messages="{
									'required': 'необходимо выбрать данные из справочника',
								}"
								:disable-custom-value="true"
								@setCompanyInfo="(value) => fullCompany = value"
							/>
							<FormulateInput
								type="text"
								label="ИНН*"
								name="inn"
								placeholder="Введите значение"
								validation-name="ИНН"
								validation="bail|number|required"
								:validation-messages="{
									number: 'ИНН должен состоять из цифр',
									required: 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="КПП"
								name="kpp"
								placeholder="Введите значение"
								validation-name="КПП"
								validation="bail|number"
								:validation-messages="{
									number: 'КПП должен состоять из цифр',
								}"
							/>
							<FormulateInput
								type="text"
								label="ОГРН*"
								name="ogrn"
								placeholder="Введите значение"
								validation-name="ОГРН"
								validation="bail|number|required"
								:validation-messages="{
									number: 'ОГРН должен состоять из цифр',
									required: 'обязательно к заполнению',
								}"
							/>
						</div>
						<div class="col-12 col-lg-6 mb-5 mb-lg-0">
							<FormulateInput
								type="text"
								label="Юридический адрес*"
								name="ur_address"
								placeholder="Введите значение"
								validation-name="Юридический адрес"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								name="company_email"
								type="text"
								label="E-mail организации*"
								placeholder="Введите значение"
								validation-name="E-mail организации"
								:validation="'bail|required|email'"
								:validation-messages="{
									'required': 'обязательно к заполнению',
									'email': 'введите корректный e-mail',
								}"
							/>
							<FormulateInput
								name="company_phone"
								type="CustomPhoneInput"
								label="Рабочий телефон*"
								inputmode="numeric"
								placeholder="Введите значение"
								validation-name="Рабочий телефон"
								:validation="'required'"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								name="company_edo"
								type="text"
								label="ID ЭДО / Идентификатор участника электронного документооборота"
								placeholder="Введите значение"
							/>
							<!-- <FormulateInput
								type="CustomDadataAddress"
								label="Адрес фактического проживания"
								name="address"
								:set-label="'full_address'"
								:input-options="{placeholder: 'Введите значение'}"
								:request-options="{
									from_bound: { value: 'country' },
									to_bound: { value: 'flat' },
								}"
								:style-classes="'user-profile-dadata-input position-relative'"
								validation-name="address"
								class="user-profile-field"
								@setAddressInfo="(value) => fullUserAddress = value"
							/> -->
						</div>
					</div>
					<div class="row mb-4">
						<div class="col-12 description strong mb-5">
							Дополнительные контакты для связи
						</div>
						<FormulateInput
							v-model="values.additional_last_name"
							type="text"
							label="Фамилия"
							name="last_name"
							placeholder="Введите значение"
							class="col-12 col-md-12 col-lg-6"
							validation-name="Фамилия"
						/>
						<FormulateInput
							v-model="values.additional_first_name"
							type="text"
							label="Имя"
							name="first_name"
							placeholder="Введите значение"
							class="col-12 col-md-12 col-lg-6"
							validation-name="Имя"
						/>
						<FormulateInput
							v-model="values.additional_email"
							type="text"
							class="col-12 col-md-12 col-lg-6"
							label="E-mail"
							name="email"
							placeholder="Введите значение"
							validation-name="E-mail"
						/>
						<FormulateInput
							v-model="values.additional_phone"
							type="CustomPhoneInput"
							label="Телефон для связи"
							name="additional_phone"
							placeholder="Введите значение"
							class="col-12 col-md-12 col-lg-6"
							inputmode="numeric"
						/>
					</div>
					<div class="row">
						<div class="col-12 d-flex flex-column justify-content-start">
							<div class="w-100 d-flex">
								<b-button
									variant="outline-primary"
									class="w-25 d-lg-none mr-2"
									@click="setStep(STEPS.INFO)"
								>
									Назад
								</b-button>
								<FormulateInput
									id="submit"
									type="submit"
									class="submit w-100"
								>
									<span v-if="isLoading">
										<b-spinner small />
									</span>
									<span v-else>Продолжить</span>
								</FormulateInput>
							</div>
							<div v-if="error" class="text-danger mb-2">
								{{ error }}
							</div>
						</div>
					</div>
				</FormulateForm>
			</div>
		</div>
	</div>
</template>

<script>
import paymentFormMixin from '~/mixins/paymentFormMixin';
import { FORM_PAYER_TYPE } from '~/utils/dictionaries';
import {
	mapActions,
	mapGetters,
	mapMutations,
	mapState,
} from 'vuex';
import formulateFormScenario from '~/mixins/formulateFormScenario';

const FORM_FIELDS = [
	'ur_address',
	'index',
	'address',
	'inn',
	'kpp',
	'name',
	'ogrn',
	'company_name_legal',
	'company_email',
	'company_phone',
	'company_edo',
	'additional_first_name',
	'additional_last_name',
	'additional_phone',
	'additional_email',
];

export default {
	name: 'CompanyStep',
	mixins: [paymentFormMixin, formulateFormScenario],
	inject: ['order'],
	props: {
		block: {
			type: Object,
			default: () => {},
		},
		payerType: {
			type: Number,
			default: FORM_PAYER_TYPE.PHYSICAL,
		},
	},
	data() {
		return {
			// Uridic fields
			values: {
				company_name_legal: null,
				company_email: null,
				company_phone: null,
				company_edo: null,
				ur_address: null,
				index: null,
				address: null,
				inn: null,
				kpp: null,
				name: null,
				ogrn: null,
				type: null,
				additional_first_name: null,
				additional_last_name: null,
				additional_phone: null,
				additional_email: null,
			},
			fullCompany: null,
			error: null,
		};
	},
	computed: {
		...mapState('scenarios/paymentForm', ['form', 'isLoading', 'orderHash', 'personData', 'isLoading']),
		...mapGetters('scenarios/paymentForm', ['isRepresentative', 'baseForm']),
	},
	watch: {
		fullCompany(val) {
			this.values.ur_address = null;
			this.values.index = null;
			this.values.inn = null;
			this.values.kpp = null;
			this.values.type = null;
			if (val && val.value) {
				this.values.name = val.value;
				if (val.data) {
					if (val.data.address) {
						this.values.ur_address = val.data.address.value;
						this.values.index = val.data.address.data?.postal_code;
					}
					this.values.inn = val.data.inn;
					this.values.kpp = val.data.kpp;
					this.values.ogrn = val.data.ogrn;
					this.values.type = val.data.type;
				}
			}
		},
	},
	mounted() {
		this.autocompleteValues();
		if (!this.isRepresentative) this.autocompleteAdditionalData();
	},
	methods: {
		...mapMutations('scenarios/paymentForm', ['setStep', 'setLoading', 'setStepError', 'setLoading']),
		...mapActions('scenarios/paymentForm', ['setCurrentStep']),
		async submitHandler() {
			this.error = null;

			this.syncForm(['payer'], { payer: this.values });
			const data = {
				user_data: {
					...this.personData.user_data,
					payer: this.values,
				},
			};

			this.setLoading(true);
			try {
				const formData = new FormData();
				this.createFormData(formData, data);
				await this.$api.syncPersonOnPayment(this.orderHash, formData);
				await this.setCurrentStep(this.STEPS.PAYMENT);
			} catch (e) {
				console.error(e);
				const { message } = e.response?.data;
				this.error = message || 'Произошла ошибка при отправке формы';

				this.setStepError(true);
			} finally {
				this.setLoading(false);
			}
		},
		autocompleteAdditionalData() {
			const { user } = this.$auth;

			this.values.additional_email = user?.email;
			this.values.additional_phone = user?.phone;
			this.values.additional_first_name = user?.first_name;
			this.values.additional_last_name = user?.last_name;
		},
		autocompleteValues() {
			const data = this.personData.user_data?.payer;
			if (!data) return;

			FORM_FIELDS.forEach((field) => {
				if (field in data) {
					if (data[field]) {
						// eslint-disable-next-line no-param-reassign
						if (field.includes('phone')) {
							this.values[field] = !data[field].startsWith('+')
								? `+${data[field]}`
								: data[field];
							return;
						}
						this.values[field] = data[field];
					}
				}
			});
		},
		validate() {
			this.$formulate.submit('companyStep');
		},
		formErrorHandler() {
			this.setStepError(true);
		},
	},
};

</script>

<style lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

@import "~/assets/styles/components/dev/order.scss";

.loyalty-card {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 1rem 2rem;
	border-radius: 0.5rem;
	font-size: 1.2rem;
	width: fit-content;
	line-height: normal;

	&-title {
		text-transform: uppercase;
		font-weight: bold;
	}
}

.custom-switch {
	padding-left: 2.2rem !important;
}

.provider {
	position: relative;
	border-bottom: 0px solid $border-color !important;
	padding-top: 0;
	padding-bottom: 1rem;
	margin-bottom: 0;
	margin-top: 1rem;

	@include media-breakpoint-up(lg) {
		border-bottom: 0 solid $border-color !important;
	}

	&:first-child {
		&::before {
			display: block;
		}
	}

	&:last-child {
		&::before {
			content: '';
			display: none;
		}
	}
	@include media-breakpoint-down(md) {
		&:nth-child(odd) {
			&::before {
				content: '';
				display: none;
			}
		}

		&:last-child {
			border-bottom: 0 solid $border-color !important;

			&::before {
				content: '';
				display: block;
				position: absolute;
				bottom: 1rem;
				top: 0;
				right: 0;
				border-right: 0px solid $border-color !important;
			}
		}
	}

	&::before {
		content: '';
		display: block;
		position: absolute;
		bottom: 1rem;
		top: 0;
		right: 0;
		border-right: 0px solid $border-color !important;
	}

	.btn-provider {
		background-color: $theme-lightblue;
		&:hover, &.active {
			.btn_provider-svg.qr {
				filter: brightness(0) invert(1);
			}
		}
	}
}
</style>
